import StarterKit from '@tiptap/starter-kit';
import TextAlign from '@tiptap/extension-text-align';
import Highlight from '@tiptap/extension-highlight';
import Image from '@tiptap/extension-image';
import TextStyle from '@tiptap/extension-text-style';
import Typography from '@tiptap/extension-typography';
import Underline from '@tiptap/extension-underline';
import Placeholder from '@tiptap/extension-placeholder';
import Emoji from '@tiptap-pro/extension-emoji';
import FontFamily from '@tiptap/extension-font-family';
import TaskItem from '@tiptap/extension-task-item';
import TaskList from '@tiptap/extension-task-list';
import Color from '@tiptap/extension-color';
import Details from '@tiptap-pro/extension-details';
import DetailsContent from '@tiptap-pro/extension-details-content';
import DetailsSummary from '@tiptap-pro/extension-details-summary';
import Table from './Table/Table';
import TableCell from './Table/Cell';
import TableHeader from './Table/Header';
import TableRow from './Table/Row';
import Link from './Link/link';
import SlashCommand from './SlashCommand/SlashCommand';
import FontSize from './FontSize/FontSize';
import SegmentContainer from './SegmentContainer';

const ExtensionKits = () => [
  StarterKit,
  TextAlign.configure({ types: ['heading', 'paragraph'] }),
  Highlight.configure({ multicolor: true }),
  Image.configure({
    HTMLAttributes: {
      style: `
      display: block;
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    `,
      class: 'rounded-xl',
    },
  }),
  SlashCommand,
  Link.configure({ openOnClick: false }),
  TextStyle,
  Typography,
  Underline,
  Placeholder,
  Emoji,
  FontFamily,
  TaskItem,
  TaskList,
  Table,
  TableCell,
  TableRow,
  TableHeader,
  Color,
  FontSize,
  SegmentContainer,
  Details.configure({
    persist: true,
    HTMLAttributes: {
      class: 'details',
    },
  }),
  DetailsSummary,
  DetailsContent,
];

export default ExtensionKits;
